import React, { useEffect, useState } from 'react';
import { Row, Col, Tabs, Form, Input, Button, Modal, Dropdown, Card, notification, Upload, Space, Select } from 'antd';
import axios from 'axios';
import Photo from './components/PhotoUpdateV2';
import { SketchPicker } from 'react-color';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import QAndAList from './components/QAndAList';
import Sugopic from './components/Image';
import ReactRouterPrompt from "react-router-prompt";
import { useForm } from 'antd/es/form/Form';



const Editpage = (props) => {
  const items = [
    {
      label: `公司資訊`,
      key: 2,
      children: <Row gutter={[0, 16]} style={{ borderRadius: '0px 15px 15px 15px', }}>
        <Col span={24} >
          <EditCompanyInfo />
        </Col>
        <Col span={24} >
          <EditStyle />
        </Col>
        <Col span={24}>
          <EditIcon />
        </Col>
      </Row>,
    },
    {
      label: `公司地圖`,
      key: 11,
      children: <div style={{ borderRadius: '0px 15px 15px 15px', }}>
        <EditMap id={11} />
      </div>,
    },
    {
      label: `Q&A`,
      key: 7,
      children: <div style={{ borderRadius: '0px 15px 15px 15px', }}>
        <QAndAList />
      </div>,
    }
  ];
  useEffect(() => {
    document.title = "形象管理"
  }, [])
  return <>
    <Row justify={'center'}>
      <Col span={23}>
        <div style={{ margin: '20px 0px', fontSize: '40px' }}>形象管理</div>
      </Col>
      <Col span={23}>
        <Tabs
          tabBarGutter={0}
          defaultActiveKey="1"
          type="card"
          size={'large'}
          items={items}
          onChange={(e) => { }}
        />
      </Col>
    </Row>
  </>
}
const EditCompanyInfo = () => {
  const [form] = useForm();
  const success_or_failure = (value) => {
    if (value === "success") {
      notification.success({
        message: '成功',
        description: "編輯成功"
      })
      return true
    } else {
      notification.error({
        message: '錯誤',
        description: "發生未知錯誤"
      })
      return false
    }
  }
  const save = (value) => {
    axios.patch("/shopping/api/mall/contact", [
      {
        contact_id: 3,
        phone: value.phone,
        address: value.address,
        email: value.email
      }
    ])
      .then(response => {
        success_or_failure(response.data.find(tmp => tmp).status) && resetdata()
      })
  }
  const resetdata = () => {
    axios.get("/shopping/api/mall/contact")
      .then(response => {
        if (response.data) {
          let info = response.data.find(tmp => tmp)
          form.setFieldValue("phone", info.phone)
          form.setFieldValue("address", info.address)
          form.setFieldValue("email", info.email)
        }
      })
  }
  useEffect(() => {
    resetdata()
  }, [])
  return (
    <>
      <Row justify={'center'}>
        <Col span={22}>
          <Card style={{ background: '#F7F7F7', borderRadius: '15px', boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)', }}>
            <Row justify={'center'} gutter={[20, 20]}>
              <Col span={24}>
                <Row justify={'center'} gutter={16}>
                  <Col>
                    <EditPhoto text={"頁底圖片"} id={2} />
                  </Col>
                  <Col>
                    <EditPhoto text={"Logo"} id={9} />
                  </Col>
                  <Col>
                    <EditPhoto text={"頁尾Logo"} id={10} />
                  </Col>
                </Row>
              </Col>
              <Col>
                <Form
                  form={form}
                  name="basic"
                  labelCol={{
                    span: 8,
                  }}
                  wrapperCol={{
                    span: 16,
                  }}
                  initialvalues={{
                    remember: false,
                  }}
                  autoComplete="off"
                  onFinish={save}
                >
                  <Form.Item
                    label="電話"
                    name="phone"
                    rules={[
                      {
                        required: true,
                        message: "請輸入電話",
                      },
                      {
                        pattern: "[0-9]{2,4}[-]{1}[0-9]{6,8}$",
                        message: "請輸入正確的電話",
                      }
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="地址"
                    name="address"
                    style={{ minWidth: '300px' }}
                    rules={[
                      {
                        required: true,
                        message: "請輸入地址",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    label="電子信箱"
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: "格式錯誤",
                        type: "email",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Row justify={'center'}>
                    <Col>
                      <Form.Item>
                        <Button type='primary' htmlType="submit">儲存</Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </>
  )
}
const EditMap = ({ id }) => {
  const [content, setContent] = useState('');
  const [status, set_status] = useState(false)
  const [data, setData] = useState(false)

  const success_or_failure = (value) => {
    if (value === "success") {
      notification.success({
        message: '成功',
        description: "編輯成功"
      })
      return true
    } else {
      notification.error({
        message: '錯誤',
        description: "發生未知錯誤"
      })
      return false
    }
  }
  const save = () => {
    axios.patch("/shopping/api/company_data", { data: [{ business_data_id: id, string_name: data.string_name, string_text: content, rate: 0 }] })
      .then(response => {
        success_or_failure(response.data.status) && resetdata()
      })
  }
  const resetdata = () => {
    axios.get("/shopping/api/company_data", { params: { business_data_id: id } })
      .then(response => {
        if (response.data) {
          setData(response.data.find(tmp => tmp))
          setContent(response.data.find(tmp => tmp).string_text)
        }
      })
  }
  useEffect(() => {
    set_status(content !== data?.string_text)
  }, [content, data])
  useEffect(() => {
    resetdata()
  }, [id])
  return (
    <>
      <ReactRouterPrompt when={status} >
        {({ isActive, onConfirm, onCancel }) =>
          isActive && <Modal open={isActive} title="確定離開？" onCancel={onCancel} onOk={onConfirm} >
            您的編輯將不會被儲存
          </Modal>
        }
      </ReactRouterPrompt>
      <Row justify={'center'}>
        <Col span={22}>
          <Card style={{ background: '#F7F7F7', borderRadius: '15px', boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)', }}>
            <Row justify={'center'} gutter={[20, 20]}>
              <Col span={20}>
                <Input.TextArea value={content} onChange={e => setContent(e.target.value)} />
              </Col>
              <Col span={20}>
                <div dangerouslySetInnerHTML={{
                  __html: content.replace(`width="600" height="450"`, `width="100%" height="100%"`)
                }} />

              </Col>
              <Col span={20} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button onClick={save} type="primary">儲存</Button>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

    </>
  )
}
const EditSticker = () => {
  const [file, setFile] = useState([])
  const produce = (info) => {
    file.length ?
      axios
        .get('/shopping/api/manage/sticker_pdf', {
          responseType: "blob",
          params: {
            file: file,
            y: info.y,
            x: info.x
          }
        }).then(response => {
          let blob = new Blob([response.data], { type: "application/pdf" })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = '貼紙.pdf'
          link.click()
        })
      :
      Modal.warning({
        title: "提示",
        content: "請選擇一張圖片"
      })
  }

  return <>
    <Row>
      <Col span={12}>
        <Photo
          fileid={null}
          srcdata={(e) => setFile(e)}
        />
      </Col>
      <Col span={12}>
        <Row>
          <Form
            onFinish={produce}
          >
            <Form.Item
              name="y"
              rules={[
                {
                  required: true,
                  message: '請勿空白',
                }
              ]}
            >
              <Input min={1} addonAfter={<>個</>} addonBefore={<> 一列</>} />
            </Form.Item>
            <Form.Item
              name="x"
              rules={[
                {
                  required: true,
                  message: '請勿空白',
                }
              ]}
            >
              <Input min={1} addonAfter={<>個</>} addonBefore={<>一行</>} />
            </Form.Item>
            <Form.Item>
              <Button htmlType='submit'>產生</Button>
            </Form.Item>
          </Form>
        </Row>
      </Col>
    </Row>
  </>
}
const EditStyle = () => {
  const [form] = Form.useForm();
  const [formList, setFormList] = useState([
    {
      label: "標題顏色",
      name: "title_color",
      color: { r: 255, g: 255, b: 255, a: 100 },
      dropdown: false
    }, {
      label: "底部區塊顏色",
      name: "footer_color",
      color: { r: 255, g: 255, b: 255, a: 100 },
      dropdown: false
    }, {
      label: "區塊顏色",
      name: "card_color",
      color: { r: 255, g: 255, b: 255, a: 100 },
      dropdown: false
    }
  ])
  const success_or_failure = (value) => {
    if (value === "success") {
      notification.success({
        message: '成功',
        description: "編輯成功"
      })
      return true
    } else {
      notification.error({
        message: '錯誤',
        description: "發生未知錯誤"
      })
      return false
    }
  }
  const handleChange = (color, i) => {
    setFormList(pre => { pre[i]["color"] = color.rgb; return [...pre] })
  };
  const edit = () => {
    let list = formList.map((tmp, index) => ({ business_data_id: index + 6, string_name: `${tmp.label},${tmp.name}`, string_text: `${tmp.color.r}, ${tmp.color.g}, ${tmp.color.b}, ${tmp.color.a}`, rate: 0 }))
    axios.patch("/shopping/api/company_data", { data: list })
      .then(response => {
        success_or_failure(response.data.status)
      })
  }

  useEffect(() => {
    setFormList([]);
    axios.get("shopping/api/company_data")
      .then(response => {
        response.data && response.data.forEach(tmp => {
          if ([6, 7, 8].includes(tmp.business_data_id)) {
            let list = tmp.string_text.split(",")
            setFormList(pre => [...pre, {
              label: tmp.string_name.split(",")[0],
              name: tmp.string_name.split(",")[1],
              color: { r: parseInt(list[0]), g: parseInt(list[1]), b: parseInt(list[2]), a: parseInt(list[3]) },
              dropdown: false
            }])
          }
        });
      })
  }, [])
  return (<>
    <Row justify={'center'}>
      <Col span={22}>
        <Card style={{ background: '#F7F7F7', borderRadius: '15px', boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)', }}>
          <Form style={{ width: '100%' }} form={form} onFinish={() => edit()}>
            <Row justify={'center'} gutter={[20, 20]}>
              <Col span={20}>
                <Row justify={'space-around'}>
                  {formList.map((tmp, index) => <Col span={24} key={index}>
                    <Form.Item
                      label={tmp.label}
                      name={tmp.name}
                    >
                      <Dropdown
                        dropdownRender={() =>
                          <SketchPicker width={250} color={formList[index]["color"]} onChange={(color) => handleChange(color, index)} />
                        }
                        trigger={["click"]}
                        open={formList[index]["dropdown"]}
                      >
                        <Button style={{
                          width: '32px',
                          height: '1em',
                          borderRadius: '2px ',
                          borderColor: "#000000",
                          background: `rgba(${formList[index]["color"].r}, ${formList[index]["color"].g}, ${formList[index]["color"].b}, ${formList[index]["color"].a})`,
                        }}
                          onClick={() => setFormList(pre => { pre[index]["dropdown"] = !pre[index]["dropdown"]; return [...pre] })}
                        />
                      </Dropdown>
                    </Form.Item>
                  </Col>
                  )}
                </Row>
              </Col>
              <Col span={20}>
                <Form.Item style={{ width: '100%' }}>
                  <Row gutter={[20, 20]} justify={'center'}>
                    <Col>
                      <Button type="primary" htmlType="submit">
                        儲存
                      </Button>
                    </Col>
                  </Row>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card>
      </Col>
    </Row>
  </>)
}
const EditPhoto = ({ text, id }) => {
  const [logoFileId, setLogoFileId] = useState(null)
  const success_or_failure = (value) => {
    if (value === "success") {
      notification.success({
        message: '成功',
        description: "編輯成功"
      })
      return true
    } else {
      notification.error({
        message: '錯誤',
        description: "發生未知錯誤"
      })
      return false
    }
  }
  const uploadButton = (
    <div>
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        上傳
      </div>
    </div>
  );
  const delphoto = (fileid) => {
    axios
      .delete(`/shopping/api/mall/photo`, {
        data: { file: [{ file_id: fileid }] },
      })
      .then((response) => {
        setLogoFileId(null);
      });
  };
  const getFileUrl = (tmp) => {
    axios
      .get(`/shopping/api/mall/photo?file_id=${tmp}`, { responseType: "blob" })
      .then((response) => {
        var blob_ = new Blob([response.data], {
          type: "img/png",
        });
        const dataurl = URL.createObjectURL(blob_);
        setLogoFileId(dataurl);
      });
  };
  const setPhoto = (info, id) => {
    let formData = new FormData();
    formData.append(`file[0][inputFile]`, info.originFileObj);
    info.status === "done" && axios.post(`/shopping/api/mall/file`, formData)
      .then((response) => {
        getFileUrl(response.data?.file.find(tmp => tmp).file_id)
        save(response.data?.file.find(tmp => tmp).file_id, id)
      });
  };
  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };
  const save = (id, i) => {
    axios.patch("/shopping/api/company_data", { data: [{ business_data_id: i, string_name: ``, string_text: ``, rate: id }] })
      .then(response => {
        success_or_failure(response.data.status)
      })
  }
  useEffect(() => {
    axios.get("shopping/api/company_data", { params: { business_data_id: id } })
      .then(response => {
        response.data && getFileUrl(response.data.find(tmp => tmp).rate)
      })
  }, [])
  return (<>
    <Row>
      <Col span={24}>
        {text}
        <Upload
          accept="image/png, image/jpeg, image/jpg"
          customRequest={dummyRequest}
          listType="picture-card"
          maxCount={1}
          onRemove={(e) => delphoto(e.file_id)}
          onChange={(e) => setPhoto(e.file, id)}
          showUploadList={false}
        >
          {logoFileId ? (
            <img
              src={logoFileId}
              alt="avatar"
              style={{
                width: '100%',
              }}
            />
          ) : (
            uploadButton
          )}
        </Upload>
      </Col>
    </Row>
  </>)
}
const EditIcon = () => {
  const [form] = Form.useForm(null);
  const defalutIconData = [
    { value: "google", label: "google" }, 
    { value: "line", label: "line" }, 
    { value: "shopee", label: "shopee" }, 
    { value: "instagram", label: "instagram" }, 
    { value: "facebook", label: "facebook" }
  ]
  const [data, setData] = useState();
  const [iconData, setIconData] = useState()
  const [iconPic, setIconPic] = useState()
  const [status, setStatus] = useState();
  useEffect(() => {
    setIconData(defalutIconData)
    setIconPic({})
    setStatus([null, null, null])
    reset()
  }, [])
  const reset = () => {
    axios.get('/shopping/api/mall/community_connect')
      .then((res) => {
        form.setFieldValue("data", res.data)
        res.data.forEach((tmp, i) => {
          setIconPic(pre => { pre[i] = tmp.icon; return pre })
        })
        setData(res.data)
      })
  }
  const onFinish = (values) => {
    let postList = []
    let patchList = []
    let deleteList = data.filter((e) => !values.data.find(e1 => e1.community_connect_id === e.community_connect_id))
    values.data.forEach(tmp => {
      tmp.community_name = tmp.icon
      if (tmp.community_connect_id) {
        patchList.push(tmp)
      } else {
        delete tmp.community_connect_id
        postList.push(tmp)
      }
    })
    if (deleteList.length) {
      axios.delete('/shopping/api/mall/community_connect', { data: deleteList })
        .then((res) => {
          setStatus(pre => { pre[0] = (res.data.filter(tmp => tmp.status === "success").length === deleteList.length); return [...pre] })
        })
    } else {
      setStatus(pre => { pre[0] = true; return [...pre] })
    }
    if (postList.length) {
      axios.post('/shopping/api/mall/community_connect', postList)
        .then((res) => {
          setStatus(pre => { pre[1] = (res.data.filter(tmp => tmp.status === "success").length === postList.length); return [...pre] })
        })
    } else {
      setStatus(pre => { pre[1] = true; return [...pre] })
    }
    if (patchList.length) {
      axios.patch('/shopping/api/mall/community_connect', patchList)
        .then((res) => {
          setStatus(pre => { pre[2] = (res.data.filter(tmp => tmp.status === "success").length === patchList.length); return [...pre] })
        })
    } else {
      setStatus(pre => { pre[2] = true; return [...pre] })
    }
  };
  useEffect(() => {
    if (status && status[0] !== null && status[1] !== null && status[2] !== null) {
      if (status[0] && status[1] && status[2]) {
        reset()
        notification.success({
          message: "成功",
          description: "編輯成功",
        });
      } else {
        notification.error({
          message: "錯誤",
          description: "發生未知錯誤",
        });
      }
      setStatus([null, null, null])
    }
  }, [status])
  const choose = (e, info, key) => {
    let data = info;
    let list = [];
    setIconPic(pre => { pre[key] = e; return pre })
    defalutIconData.forEach((tmp) => {
      if (data && data.includes(tmp.value)) {
        list.push({ ...tmp, disabled: true });
      } else {
        list.push({ ...tmp, disabled: false });
      }
    });
    setIconData(list);
  };
  return (
    <>
      <Row justify={'center'}>
        <Col span={22}>
          <Card style={{ background: '#F7F7F7', borderRadius: '15px', boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25)', }}>
            <Form
              form={form}
              onFinish={onFinish}
              style={{
                maxWidth: 600,
              }}
              autoComplete="off"
            >
              <Form.List
                name="data">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <Space
                        key={key}
                        style={{
                          display: 'flex',
                          marginBottom: 8,
                        }}
                        align="baseline"
                      >
                        <Form.Item
                          {...restField}
                          name={[name, 'community_connect_id']}
                          hidden
                        >
                          <Input />
                        </Form.Item>
                        <Sugopic img={iconPic[key]} style={{ height: '48px' }} />
                        <Form.Item
                          {...restField}
                          name={[name, 'icon']}
                          rules={[
                            {
                              required: true,
                              message: '請勿空白',
                            },
                          ]}
                        >
                          <Select
                            style={{ width: 200 }}
                            options={
                              iconData
                            }
                            onChange={(e) =>
                              choose(
                                e,
                                form
                                  .getFieldValue(`data`)
                                  .map((tmp) => tmp.icon),
                                key
                              )
                            }
                          />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, 'community_link']}
                          rules={[
                            {
                              required: true,
                              message: '請勿空白',
                            },
                          ]}
                        >
                          <Input placeholder="網址" />
                        </Form.Item>
                        <MinusCircleOutlined onClick={() => remove(name)} />
                      </Space>
                    ))}
                    <Form.Item>
                      <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                        新增
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  儲存
                </Button>
              </Form.Item>
            </Form>
          </Card>

        </Col>
      </Row>

    </>
  )
}

export default Editpage;